module.exports = __webpack_public_path__ + "img/Withdraw-gold.2247f48d.svg";